export enum PoliticModalTypes {
    OPEN_POLITIC_MODAL = '[auth] OPEN_POLITIC_MODAL',
    CLOSE_POLITIC_MODAL = '[auth] CLOSE_POLITIC_MODAL',
    REACTIVE_POLITIC_COL = '[auth] REACTIVE_POLITIC_COL',
    UPDATE_POLITICS = '[auth] UPDATE_POLITICS',
    OPEN_HOLIDAYS = '[auth] OPEN_HOLIDAYS'
}